<div class="batch-history-modal-wrapper">
  <div class="batch-history-modal" #modal>
    <div class="batch-history-modal__title">
      Batch history
      <span class="close" (click)="onClose.emit()">
        <pdq-icon icon="close"></pdq-icon>
      </span>
    </div>
    <div class="batch-history-modal__search">
      <pdq-input placeholder="Search in batch history" (onKeyup)="filterBatches($event)"></pdq-input>
    </div>
    <div class="batch-history-modal__table">
      <div class="batch-history-modal__table__head"></div>
      <div class="batch-history-modal__table__body">
        @for (batch of batches; track batch) {
          <fulfill-batch-list-table-row [batch]="batch" variant="secondary"></fulfill-batch-list-table-row>
        }
      </div>
    </div>
    <div class="batch-history-modal__pagination">
      <pdq-dropdown [options]="paginationOptions" placeholder="Show 10 batches" (onChange)="onPerPageChanges($event)">
      </pdq-dropdown>
      <pdq-pagination
        [perPageActiveOption]="batchesPerPage"
        [totalCountItems]="count"
        [allPages]="{}"
        [activePage]="currentPage"
        [totalPages]="totalPages"
        (onPageChange)="paginate($event)">
      </pdq-pagination>
    </div>
  </div>
</div>
